module.exports = class Ajax {

    static decode(value) {
        try {
            let ret = decodeURIComponent(value);
            return ret === value ? ret : Ajax.decode(ret);
        } catch(e) {
            return value;
        }
    }

    static serializeGetUrl(ajax) {
        if (ajax.isPost || ![...ajax._FormData].length) return ajax.url;

        // simulace chyby původního vutajax - při serializaci get formu se z action neodstraní query, duplicitní klíče se odstraní
        // na backendu může být tato chyba zneužita, pozor !!

        let exploded = ajax.url.split("?");

        let url = exploded.shift();
        let query = exploded.join("?").split("#")[0];

        [
            ...query
                .split('&')
                .filter(v=>v)
                .map(e=>e.split("=")
                    .map(v=>Ajax.decode(v))
                )
            ,
        ].forEach(e=>{
// co z původní query není ve formdata, tam přidám //
            if ((ajax._FormData.get(e[0])??undefined) === undefined) {
                ajax._FormData.append(e.shift(), e.join('='));
            }
        });

        return  url
            + "?"
            + [...ajax._FormData]
                .map(v => encodeURIComponent(v[0])+"="+encodeURIComponent(v[1]))
                .join('&');

    }

    static getPostOptions(ajax) {
        return {
            method : ajax.isPost ? 'POST' : 'GET',
            headers : {
                'X-Requested-With': 'XMLHttpRequest',
                'X-VutAjax': 'true',
            },
            body : ajax.isPost ? ajax._FormData : undefined,
        }
    }

    constructor(url, method) {

        this.url = url;
        this.isPost = method?.toString?.().toLowerCase?.() === 'post';
        this._FormData = new FormData;

    }

    addData(key, value) {

        switch (typeof key) {
            case "string":
                this._FormData.append(key, value);
                break;
            case "object":
                for (let k in key) {
                    if (key.hasOwnProperty(k)) {
                        this._FormData.append(k, key[k]);
                    }
                }
                break;
            default:
                throw new Exception('Chybna data');
                break;
        }
    }

    send() {

        let r;

        return new Promise((resolve, reject)=> {
            fetch(
                this.requested_url = Ajax.serializeGetUrl(this),
                Ajax.getPostOptions(this),
            )
                .then(response=> {
                    r = response;
                    return response.text()
                })
                .then(text=>{
                    if (r.status !== 200) resolve({data:null, error:r, errorStatus:-4});
                    try {
                        let data = JSON.parse(text);
                        resolve({data, error:null, errorStatus:0})
                    } catch(e) {
                        resolve({data:null, error:'Nerozparsovaný JSON: ' + text, errorStatus:-3})
                    }
                })
                .catch(response=>{
                    resolve({data:null, error:response, errorStatus:-4})
                });
        });

    }

}